//
// TypedField
//
// Return a Field for a field based on type

import { observer } from 'mobx-react-lite'
import { useContext } from 'react'

import {
    AssetField,
    AssetListField,
    BarcodeField,
    BooleanField,
    ClassField,
    ClassListField,
    FieldpickerField,
    KeyValueField,
    KeyValueListField,
    RecordField,
    RecordListField,
    TextField,
    TextListField,
} from '../fields'

import { hasValuesOption } from '../../../../stores/data/utils'
import { hashData } from '../../../../utils/utils'
import { LocalizedContext } from './LocalizedContext'

export const TypedField = observer(function TypedField({
    field,
    fromClass,
    editable,
    force_readonly,
    component,
    record,
    worksheet,
    active_class,
    visited_gids,
}) {
    const context_is_localized = useContext(LocalizedContext)

    if (!field) {
        return null
    }

    let renderkey = record.gid + '.' + field.gid + '.' + field.type
    if (field.options) {
        renderkey = renderkey + '.' + hashData(field.options)
    }

    const sharedAttributes = {
        enabled: editable,
        record,
        field,
        fromClass,
        component,
        renderkey,
        worksheet,
        force_readonly,
        visited_gids,
    }

    switch (field.type) {
        case 'record':
            return <RecordField {...sharedAttributes} />
        case 'recordlist':
            return <RecordListField {...sharedAttributes} />
        case 'file':
        case 'image':
            return <AssetField {...sharedAttributes} />
        case 'filelist':
        case 'imagelist':
            return <AssetListField {...sharedAttributes} />
        case 'fieldpicker':
            return <FieldpickerField {...sharedAttributes} />
        case 'class':
            return (
                <LocalizedContext.Provider
                    value={context_is_localized || field.is_localized}
                >
                    <ClassField
                        {...sharedAttributes}
                        renderkey={renderkey + '.' + record.data_hash}
                    />
                </LocalizedContext.Provider>
            )
        case 'classlist':
            return (
                <LocalizedContext.Provider
                    value={context_is_localized || field.is_localized}
                >
                    <ClassListField
                        {...sharedAttributes}
                        renderkey={renderkey + '.' + record.data_hash}
                    />
                </LocalizedContext.Provider>
            )
        case 'boolean':
            return <BooleanField {...sharedAttributes} />
        case 'barcode':
            return <BarcodeField {...sharedAttributes} />
        case 'textlist':
            if (hasValuesOption(field)) {
                return <KeyValueListField {...sharedAttributes} />
            }
            return <TextListField {...sharedAttributes} />
        case 'text':
        case 'textline':
        case 'number':
        case 'decimal':
        case 'code':
        default:
            if (field.type === 'textline' && hasValuesOption(field)) {
                return <KeyValueField {...sharedAttributes} />
            }
            return <TextField {...sharedAttributes} />
    }
})
